export default __webpack_public_path__ + "static/media/img-guide-02@3x.50b6f14f.png";